import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {
  Modal,
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalHeader,
  ModalSubmitButton,
  showModal,
  showNewNotification,
} from '@edna/components';

import {ModalCenterImage, Text} from 'src/components/primitives';
import {CleaningLightImage} from 'src/images';

import {useHideAvailableTariffMutation} from '../api';
import {TAvailableTariff} from '../definitions';
import {showLinkedSubjectsModal} from './LinkedSubjectsModal';
import * as S from './style';

const HideTariffModal = React.memo<{
  closeModal: TEmptyFunction;
  tariff: TAvailableTariff;
  linkedSubjects: number[];
}>(({closeModal, tariff, linkedSubjects}) => {
  const {t} = useTranslation();

  const [hideTariff, {isLoading}] = useHideAvailableTariffMutation();

  const handleSubmit = React.useCallback(async () => {
    try {
      await hideTariff(tariff.id).unwrap();
      closeModal();
      showNewNotification({
        type: 'SUCCESS',
        message: t('Tariffs:successNotifications.hideTariff', {name: tariff.name}),
      });
    } catch (e) {}
  }, [tariff, closeModal]);

  return (
    <Modal width="430px">
      <ModalHeader>{t('Tariffs:hideModal.title')}</ModalHeader>
      <ModalContent>
        <Text secondary>
          <Trans i18nKey={'Tariffs:hideModal.subtitle'}>
            <S.Link onClick={() => showLinkedSubjectsModal(linkedSubjects)} />
          </Trans>
        </Text>
      </ModalContent>
      <ModalCenterImage as={CleaningLightImage} />
      <ModalActions>
        <ModalCancelButton onClick={closeModal}>{t('Common:button.cancel')}</ModalCancelButton>
        <ModalSubmitButton onClick={handleSubmit} disabled={isLoading} loading={isLoading}>
          {t('Tariffs:hideModal.submitButton')}
        </ModalSubmitButton>
      </ModalActions>
    </Modal>
  );
});

HideTariffModal.displayName = 'HideTariffModal';

export const showHideTariffModal = (tariff: TAvailableTariff, linkedSubjects: number[]) =>
  showModal((closeModal) => (
    <HideTariffModal closeModal={closeModal} tariff={tariff} linkedSubjects={linkedSubjects} />
  ));
